/* Ovena reusable PDP gallery — main image + thumbnail strip, variant-aware.
   Usage:
     var g = OvenaGallery.init({
       mount: '#pdpgallery',
       variants: { '2x2': [{src,thumb,alt,w,h}, ...], '4x4': [...] },
       defaultKey: '2x2'
     });
     // when the size/length radio changes: g.setVariant('4x4');
   Keeps one image set per variant; first image of a set is the main/LCP. */
(function () {
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  window.OvenaGallery = {
    init: function (opts) {
      var mount = typeof opts.mount === 'string' ? document.querySelector(opts.mount) : opts.mount;
      if (!mount) return null;
      var variants = opts.variants || {};
      var key = opts.defaultKey || Object.keys(variants)[0];
      mount.classList.add('pdp-gallery');
      mount.innerHTML = '';
      var main = el('div', 'pdp-main');
      var mimg = el('img', null, { id: opts.mainId || 'galMain', fetchpriority: 'high', decoding: 'async' });
      main.appendChild(mimg);
      var thumbs = el('div', 'pdp-thumbs', { role: 'tablist', 'aria-label': 'Product images' });
      mount.appendChild(main);
      mount.appendChild(thumbs);

      function show(im, btn) {
        mimg.src = im.src;
        mimg.alt = im.alt || '';
        if (im.w) mimg.width = im.w;
        if (im.h) mimg.height = im.h;
        [].forEach.call(thumbs.children, function (c) {
          c.classList.remove('sel'); c.setAttribute('aria-selected', 'false');
        });
        if (btn) { btn.classList.add('sel'); btn.setAttribute('aria-selected', 'true'); }
      }
      function render(k) {
        if (!variants[k] || !variants[k].length) return;
        key = k;
        var imgs = variants[k];
        thumbs.innerHTML = '';
        imgs.forEach(function (im, i) {
          var b = el('button', 'pdp-thumb', { type: 'button', role: 'tab', 'aria-label': 'View image ' + (i + 1) });
          var t = el('img', null, { loading: 'lazy', alt: '', width: 72, height: 72 });
          t.src = im.thumb || im.src;
          b.appendChild(t);
          b.addEventListener('click', function () { show(im, b); });
          b.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' && b.nextSibling) { e.preventDefault(); b.nextSibling.focus(); b.nextSibling.click(); }
            if (e.key === 'ArrowLeft' && b.previousSibling) { e.preventDefault(); b.previousSibling.focus(); b.previousSibling.click(); }
          });
          thumbs.appendChild(b);
        });
        show(imgs[0], thumbs.firstChild);
      }
      render(key);
      return {
        setVariant: function (k) { if (variants[k]) render(k); },
        mainImg: mimg,
        current: function () { return key; }
      };
    }
  };
})();
